import { Badge, BadgeProps } from "@chakra-ui/react";
import { OrderingPlatformType } from "__generated__/gql/graphql";
import { isEqual } from "lodash";

export const ORDERING_PLATFORM_TYPE_LABELS: Record<
  OrderingPlatformType,
  string
> = {
  [OrderingPlatformType.NATL_DIST]: "National Distributor",
  [OrderingPlatformType.REG_DIST]: "Regional Distributor",
  [OrderingPlatformType.DIRECT_RETAILER]: "Direct Retailer",
  [OrderingPlatformType.OTHER]: "Other",
};

export const ORDERING_PLATFORM_TYPES = [
  OrderingPlatformType.NATL_DIST,
  OrderingPlatformType.REG_DIST,
  OrderingPlatformType.DIRECT_RETAILER,
  OrderingPlatformType.OTHER,
];

export function getIsEveryOptionSelected(value: OrderingPlatformType[]) {
  const sortedValue = value.slice().sort();
  const sortedOptions = ORDERING_PLATFORM_TYPES.slice().sort();
  return isEqual(sortedValue, sortedOptions);
}

type Props = BadgeProps & {
  orderingPlatformType: OrderingPlatformType;
};

export default function OrderingPlatformTypeBadge({
  orderingPlatformType,
  ...rest
}: Props) {
  return (
    <Badge variant="outline" {...rest}>
      {ORDERING_PLATFORM_TYPE_LABELS[orderingPlatformType]}
    </Badge>
  );
}
